// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"dd7e07d9","254":"2fa6ddd7","281":"2e947c1a","439":"d5b56639","610":"0ce9836f","845":"9d89711f","871":"ddaf2fe0"}[chunkId] + ".chunk.js";
};